import ListAltIcon from "@mui/icons-material/ListAlt";
import BalanceIcon from "@mui/icons-material/Balance";
import CompareArrowsIcon from "@mui/icons-material/CompareArrows";
import BuildIcon from "@mui/icons-material/Build";
import TimelineIcon from "@mui/icons-material/Timeline";
import MovieCreationIcon from "@mui/icons-material/MovieCreation";
import ScienceIcon from "@mui/icons-material/Science";
import FormatQuoteIcon from "@mui/icons-material/FormatQuote";
import AutoStoriesIcon from "@mui/icons-material/AutoStories";
import QuestionAnswerIcon from "@mui/icons-material/QuestionAnswer";
import TipsAndUpdatesIcon from "@mui/icons-material/TipsAndUpdates";
import ArticleIcon from "@mui/icons-material/Article";
import type { SvgIconComponent } from "@mui/icons-material";

const CONTENT_FORMAT_ICONS: Record<string, SvgIconComponent> = {
  listicle: ListAltIcon,
  comparison: BalanceIcon,
  tutorial: BuildIcon,
  timeline: TimelineIcon,
  "story-documentary": MovieCreationIcon,
  "myth-vs-fact": ScienceIcon,
  "before-after": CompareArrowsIcon,
  "quote-motivation": FormatQuoteIcon,
  storytelling: AutoStoriesIcon,
  qa: QuestionAnswerIcon,
  tips: TipsAndUpdatesIcon,
  default: ArticleIcon,
};

export function getContentFormatIcon(slug: string | null | undefined): SvgIconComponent {
  if (slug && CONTENT_FORMAT_ICONS[slug]) {
    return CONTENT_FORMAT_ICONS[slug];
  }
  return CONTENT_FORMAT_ICONS.default;
}
